import type * as React from "react";
import { useState } from "react";

import { styled, TextField, type TextFieldProps, Box, IconButton } from "~/common/mui";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";

export interface PasswordInputProps extends Omit<TextFieldProps, "variant"> {
  isHighlight?: boolean;
  helperLabel?: React.ReactNode;
  shrink?: boolean;
}

const StyledWrapper = styled(Box)({
  position: "relative",
  "& input": {
    cursor: "auto",
  },
  width: "100%",
});

export const PasswordInput: React.FC<PasswordInputProps> = (props) => {
  const { value, onChange, inputRef, name, ...inputProps } = props;

  const [showPassword, setShowPassword] = useState(false);
  const toggleShowPassword = () => setShowPassword((prev) => !prev);

  return (
    <StyledWrapper>
      <TextField
        fullWidth
        value={value}
        onChange={onChange}
        name={name}
        inputRef={inputRef}
        type={showPassword ? "text" : "password"}
        helperText={inputProps.helperLabel}
        InputLabelProps={{ shrink: inputProps.shrink }}
        InputProps={{
          endAdornment: (
            <IconButton disabled={inputProps.disabled} onClick={toggleShowPassword} color={"primary"}>
              {showPassword ? <VisibilityOffOutlinedIcon /> : <VisibilityOutlinedIcon />}
            </IconButton>
          ),
        }}
        {...inputProps}
      />
    </StyledWrapper>
  );
};

export default PasswordInput;
